export default function ({ app, $axios }) {
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    $axios.$post('/user/user-change-language/');
  }
}
